import React from 'react';
import { IconContainer } from './IconContainer';

const ArrowLeftIcon = (props) => {
    return (
        <IconContainer ariaLabel="arrow-left" {...props}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.5234 10.8334L10.9933 15.3034L9.815 16.4817L3.3334 10L9.815 3.51833L10.9933 4.69673L6.5234 9.16673L16.6667 9.16673V10.8334L6.5234 10.8334Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { ArrowLeftIcon };